module.exports = "pegasus_template/assets/background-patterns/light-gray.png";